import { genericThreadAction, alertCreate } from './genericThreadActionCreator';
import actionTypes from '../../actionTypes';
import { fetch } from '../../../api';

const addParticipants = function addParticipants(threadId, participantIds) {
  const config = {
    fetchData: addParticipants.fetchData,
    actionCreators: addParticipants.actionCreators,
    arg: { threadId, participantIds },
  };
  return (dispatch, getState) => genericThreadAction({ dispatch, getState, ...config });
};

addParticipants.fetchData = async function addParticipantsFetchData({ arg: { threadId, participantIds } }) {
  const { payload } = await fetch(
    `message/thread/${threadId}`,
    { method: 'PUT', body: JSON.stringify({ participantIds }) }
  );
  return payload;
};

addParticipants.actionCreators = {
  init: function addParticipantsInitActionCreator({ arg: { threadId, participantIds } }) {
    const threads = [{ threadId, participantIds }];
    return {
      type: actionTypes.THREAD_CHANGE_PARTICIPANTS,
      data: { threads },
    };
  },

  failure: function addParticipantsFailureActionCreator({ error, oldState, arg: { threadId } }) {
    const threads = [{ ...oldState.data.threads[threadId] }];
    return alertCreate({
      error,
      type: actionTypes.THREAD_CHANGE_PARTICIPANTS_FAILURE,
      data: { threads },
    });
  },
};

export default addParticipants;


// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/threads/addParticipants.js